module.exports = __webpack_public_path__ + "img/iconProjectFlowPath.c48aebed.svg";